import type { DatasetIconProps } from "./DatasetIcon.type";

import { RiMapPin2Fill, RiMapPin2Line } from "react-icons/ri";

const GpsIcon = ({ filled }: DatasetIconProps) => {
  return filled ? <RiMapPin2Fill /> : <RiMapPin2Line />;
};
export default GpsIcon;
